import { Component, OnInit } from '@angular/core';
import { PropertiesService } from '../../../services/properties.service';
import { ErrorModel } from '../../../models/error.models';

@Component({
  selector: 'app-principal',
  templateUrl: './principal.component.html',
  styleUrls: ['./principal.component.css'],
  standalone: false
})
export class PrincipalComponent implements OnInit {

  propiedades: any[];
  error = new ErrorModel();

  constructor(private propserv: PropertiesService) {}

  ngOnInit(): void {
    const raw = sessionStorage.getItem('filterAdmin');
    const filtrosIniciales = raw ? JSON.parse(raw) : {};

    // carga inicial con esos filtros
    this.getPropiedades(filtrosIniciales);
  }

  /** 🔹 Trae propiedades según filtros */
getPropiedades(filtro: any) {
  const tipoOpe = filtro?.tipoOpe || 'ALL';
  const tipoPr = filtro?.tipoPr || 'ALL';
  const localidad = filtro?.localidad || 'ALL';
  const barrio = filtro?.barrio || 'ALL';
  const dormitorio = filtro?.dormitorio || 'ALL';
  const cochera = filtro?.cochera || false;
  const patio = filtro?.patio || false;
  const apCredito = filtro?.apCredito || false;
  const direccion = filtro?.direccion || '';

  return this.propserv.getAdminListProp(
    tipoOpe, tipoPr, localidad, barrio, dormitorio,
    cochera, patio, -1, direccion, 0, 100
  )
  .subscribe({
    next: (data: any[]) => {
      this.propiedades = data;
      console.log('Propiedades admin filtradas:', data);
    },
    error: (errorService) => {
      this.error.error = true;
      this.error.msjError = errorService.error.title;
    }
  });
}
Delete(id: number) {
  const ok = confirm("⚠️ ¿Seguro que deseas ELIMINAR esta propiedad? Esta acción no se puede deshacer.");
  if (!ok) return;

  this.propserv.deletePropiedad(id)
    .subscribe(() => this.removeItem(this.propiedades, id));
}

CambiarEstado(id: number, estado: boolean) {
  const msg = estado
    ? "⚠️ ¿Deseas DESHABILITAR esta propiedad? No estará visible."
    : "⚠️ ¿Deseas HABILITAR esta propiedad y volverla visible?";

  const ok = confirm(msg);
  if (!ok) return;

  const propiedad = { habilitado: !estado };
  this.propserv.SetEstado(id, propiedad)
    .subscribe(() => this.getPropiedades({}));
}



  removeItem(array: any[], id: number) {
    const index = array.findIndex(x => x.id === id);
    if (index > -1) array.splice(index, 1);
  }
}
